import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import MainContent from "./components/MainContent";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="font-sans bg-background-light dark:bg-background-dark text-slate-700 dark:text-slate-300">
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <MainContent />
        <Footer />
      </div>
    </div>
  );
}

export default App;
